import { useEffect, useState } from "react";
import { fileDownload } from "../../../api";
import {
  extractPrivateFileId,
  isPrivateFileSource,
} from "../../../helpers/fileImage";

const AuthenticatedFileImage = ({
  src,
  alt = "",
  className = "",
  fallback = null,
}) => {
  const [imageSrc, setImageSrc] = useState("");
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    if (!src) {
      setImageSrc("");
      setHasError(false);
      return;
    }

    let objectUrl = "";
    let cancelled = false;

    const loadImage = async () => {
      setHasError(false);

      if (!isPrivateFileSource(src)) {
        setImageSrc(src);
        return;
      }

      const fileId = extractPrivateFileId(src);
      if (!fileId) {
        setHasError(true);
        return;
      }

      try {
        const response = await fileDownload(fileId);
        if (cancelled || !response?.arrayBuffer) {
          if (!cancelled) setHasError(true);
          return;
        }

        const blob = new Blob([response.arrayBuffer]);
        objectUrl = URL.createObjectURL(blob);
        setImageSrc(objectUrl);
      } catch (error) {
        console.error("Error loading authenticated image", error);
        if (!cancelled) setHasError(true);
      }
    };

    loadImage();

    return () => {
      cancelled = true;
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [src]);

  if (!src || hasError) {
    return fallback;
  }

  if (!imageSrc) {
    return fallback;
  }

  return <img src={imageSrc} alt={alt} className={className} />;
};

export default AuthenticatedFileImage;
